// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#all-hospitals .el-dialog .el-dialog__body {\n  padding: 0;\n}\n#all-hospitals .container-sm-table {\n  padding: 10px 0;\n}\n#all-hospitals .primary-content-view-new {\n  margin-top: 0;\n}\n#all-hospitals .stickyNavbar {\n  padding-bottom: 5px !important;\n}\n#all-hospitals .stickyNavbar .container-sm-table {\n  padding-top: 0;\n  padding-bottom: 5px;\n}", ""]);
// Exports
module.exports = exports;
